'use strict';

angular.module('ntmApp').factory('EditForm', ['$q', '$location', '$timeout', 'FlashService', 'FormService', 'FormGenerator', 'Animation', 'ListGridHelper', 'ListGridStatus', 'FormValidator', 'ButtonExecution', 'UserInfo',
    function ($q, $location, $timeout, FlashService, FormService, FormGenerator, Animation, ListGridHelper, ListGridStatus, FormValidator, ButtonExecution, UserInfo) {

        function EditForm(data) {

            var self = this;
            var userData = null;
            var formGenerator = new FormGenerator();

            UserInfo.GetUserInfo().then(function (user) {
                userData = user;
            });

            self.action = data.action || 0;

            self.SaveData = function (method) {

                var sectionsData = [];
                var formValid = true;

                var deferred = $q.defer();
                var sequenceColumnName = self.action === 0 && ListGridStatus.gridSettings.dragging ? ListGridStatus.gridSettings.dragging.getSequenceField() : null;

                self.formData.sections.forEach(function (section) {

                    if (self.action !== 2) {
                        var validationInfo = FormValidator.validate(self.form, section.model, self.action, section.fields);

                        if (!formValid || !validationInfo.isValid()) {
                            formValid = false;
                            if (!validationInfo.isValid()) {
                                FlashService.Error(validationInfo.getError());
                            }

                            deferred.reject();

                            return;
                        }
                    }

                    var outputData = {};

                    section.sectionAttributes.forEach(function (field) {

                        var fieldValues = field.values || [];
                        var properties = field.properties ? JSON.parse(field.properties) : {};

                        if (!outputData.hasOwnProperty(properties.savekey || properties.key) && !outputData.hasOwnProperty(field.fieldName)) {

                            var savePropertyName = fieldValues.length === 0 && properties.savekey ? properties.savekey : field.fieldName;
                            if (field.letterCase && section.model[field.fieldName] && (self.action === 0 || !field.isPrimary)) {
                                switch (field.letterCase) {
                                    case 'UPPER':
                                        section.model[field.fieldName] = section.model[field.fieldName].toUpperCase();
                                        break;
                                    case 'LOWER':
                                        section.model[field.fieldName] = section.model[field.fieldName].toLowerCase();
                                        break;
                                    case 'PROPER':
                                        section.model[field.fieldName] = ListGridHelper.toProperCase(section.model[field.fieldName]);
                                        break;
                                }
                            }

                            outputData[savePropertyName] = section.model[field.fieldName];

                            if (sequenceColumnName && sequenceColumnName === field.fieldName) {
                                outputData[sequenceColumnName] = ListGridHelper.getNextSequence(field.name, data.entity);
                            }

                            switch (field.type) {
                                case ('NUMERIC'):
                                    if (field.propertyObj.displayAs && (field.propertyObj.displayAs === 'percent' || field.propertyObj.displayAs === 'progressBar')) {
                                        outputData[field.fieldName] = outputData[field.fieldName] / 100;
                                    }
                                    break;

                                case 'RADIOBOOLEAN':
                                    outputData[field.fieldName] = outputData[field.fieldName] === 'Yes' ? true : outputData[field.fieldName] === 'No' ? false : null;
                                    break;

                                case 'TIME':
                                    if (outputData[field.fieldName]) {
                                        outputData[field.fieldName] = moment(outputData[field.fieldName]).format('hh:mm A');
                                    }
                                    break;

                                case 'DATE':
                                    if (outputData[field.fieldName] && angular.isDate(outputData[field.fieldName])) {
                                        outputData[field.fieldName] = new Date(outputData[field.fieldName].setHours(new Date().getHours()));
                                    }
                                    break;

                                case ('COLOR'):
                                    if (outputData[field.fieldName] && outputData[field.fieldName].indexOf('#') === -1) {
                                        outputData[field.fieldName] = '#' + outputData[field.fieldName];
                                    }
                                    break;

                                case ('PICKLIST'):
                                    if (fieldValues.length > 0 && properties.key) {
                                        fieldValues.forEach(function (value) {
                                            if (value[field.fieldName] && value[field.fieldName] === section.model[field.fieldName] ||
                                                value[properties.display[0]] && value[properties.display[0]] === section.model[field.fieldName]) {
                                                outputData[properties.savekey || properties.key] = value[properties.key];
                                            }
                                        });
                                    }
                                
                                    if (!outputData[field.fieldName]) {
                                        section.model[properties.savekey || properties.key || field.fieldName] = null;
                                    }
                                    
                                    //TODO: rework picklist type. 413826 - ROOM_NO for Unplanned Activity
                                    /*if(properties.groupBy && field.attributeId === 413826 && outputData[field.fieldName]){
                                        var keyValue =  outputData[field.fieldName].split('/');
                                        var propertyValue = field.values.filter(v => v[properties.groupBy] === keyValue[0] && v[properties.display[0]] === keyValue[1])[0];
                                        properties.fields.forEach(f => {
                                            outputData[f] = propertyValue[f];
                                        });
                                        outputData[properties.savekey || properties.key] = propertyValue[properties.key];
                                    }*/

                                    break;

                                case ('CHECKBOXLIST'):
                                    properties = field.properties ? JSON.parse(field.properties) : {};

                                    outputData[field.fieldName] = '';
                                    if (section.model[field.fieldName] && angular.isArray(section.model[field.fieldName]) && section.model[field.fieldName].length > 0) {
                                        section.model[field.fieldName].forEach(function (item) {
                                            section.fields.forEach(function (sfield) {
                                                if (field.fieldName === sfield.key) {
                                                    var val = field.values.filter(function (el) {
                                                        return (el[properties.savekey ? properties.savekey : properties.key] === item.id);
                                                    });
                                                    if (val.length > 0) {
                                                        outputData[field.fieldName] = outputData[field.fieldName] + val[0][properties.savekey ? properties.savekey : properties.key] + ';';
                                                    }
                                                }
                                            });
                                        });
                                    }
                                    break;
                            }
                        }

                    });

                    sectionsData.push({
                        sectionId: section.mdPage,
                        data: outputData,
                        oldData: self.originalModel || {},
                        primaryKeys: self.action !== 0 ? ListGridHelper.getPrimaryKeys(self.originalModel, 'fieldName') : {}
                    });

                });

                sectionsData.forEach(function (section) {
                    if (self.action !== 0 && angular.equals(section.primaryKeys, {}) && !method) {
                        section.primaryKeys = sectionsData.filter(function (item) { return !angular.equals(item.primaryKeys, {}); })[0].primaryKeys;
                    }
                });

                if (!formValid) {
                    deferred.reject();
                    return;
                }

                var requestData = {
                    pageType: data.pageType,
                    pageId: self.formData.mdPage,
                    action: self.action,
                    sections: sectionsData

                };

                var loading = FlashService.Loading();

                if (method) {

                    ButtonExecution.RunMethod(method, requestData).then(function (result) {
                        if (result.success !== false) {
                            if (!data.doNotReset) {
                                self.ComposeData();
                            } else {
                                if (data.model) {
                                    updateOriginalModel(result.data.data);
                                }
                            }
                            if (self.form) {
                                self.form.$setPristine();
                            }

                            if (data.onDataUpdatedMethod) {
                                data.onDataUpdatedMethod();
                            }
                        }

                        if (result.data && result.data.message) {
                            FlashService.Success(result.data.message);
                        }

                        deferred.resolve(result);

                        // Added timeout because of overlapping LoadingModal by ErrorModal invoked from server error and therefore troubles with dismissing of 2 modals
                        $timeout(function () {
                            loading.dismiss();
                        }, 500);
                    });

                } else {

                    FormService.SaveForm(requestData).then(function (result) {
                        if (result.success !== false) {
                            if (!data.doNotReset) {
                                self.ComposeData();
                            } else {
                                if (data.model) {
                                    updateOriginalModel(result.data.data);
                                }
                            }
                            if (self.form) {
                                self.form.$setPristine();
                            }

                            if (data.onDataUpdatedMethod) {
                                data.onDataUpdatedMethod();
                            }

                            if (formGenerator.DataCollection) {
                                formGenerator.DataCollection.saveData();
                            }

                        }

                        if (result.data && result.data.message) {
                            FlashService.Success(result.data.message);
                        }

                        deferred.resolve(result);

                        // Added timeout because of overlapping LoadingModal by ErrorModal invoked from server error and therefore troubles with dismissing of 2 modals
                        $timeout(function () {
                            loading.dismiss();
                        }, 500);
                    });
                }

                return deferred.promise;
            };

            self.ComposeData = function () {

                self.originalModel = data.model ? angular.copy(data.model) : {};

                ListGridStatus.columns = [];

                self.formData = data;

                self.formData.sections = data.generalPageSection;

                self.formData.sections.forEach(function (section) { ListGridStatus.columns = ListGridStatus.columns.concat(section.sectionAttributes); });

                self.columns = ListGridStatus.columns;

                self.formData.sections.forEach(function (section) {
                    section.unchangedFields = angular.copy(section.sectionAttributes);
                    section.fields = formGenerator.prepareFormFields(section.sectionAttributes, data.sectionId, data.model || [], self.action);
                    section.model = formGenerator.getModel();
                    section.unchangedModel = angular.copy(section.model);
                    section.options = formGenerator.getOptions();
                    section.formClass = section.displayType ? section.displayType.toLowerCase() : 'stacked';

                    if (self.formData.columAnimations) {
                        var animation = new Animation(userData);
                        animation.setModel(section.model);
                        animation.setAnimationLevel("page");
                        animation.initAnimation(self.formData.columAnimations);
                        section.fields.forEach(function (field) {
                            animation.performDialogAnimation(field);
                        });

                        section.showSection = function () {
                            return animation.performSectionAnimation(section.mdPage);
                        };

                    } else {
                        section.showSection = function () { return true; };
                    }
                });

                self.getModel = formGenerator.getModel;

                if (self.form) {
                    self.form.$setPristine();
                }

                $timeout(function () {
                    formGenerator.form = self.form;
                }, 500);
            };

            self.RunAction = function (button) {
                switch (button.buttonType) {
                    case 'EXECUTE':
                        if (button.methodName) {
                            self.SaveData(button.methodName);
                        }
                        break;
                    case 'OPENPAGE':
                        $location.path(button.redirectTo);
                        break;
                }
          
            };

            self.Cancel = function () {
                self.ComposeData();

                if (self.formData.close) {
                    self.formData.close();
                }
            };

            function updateOriginalModel(responce) {
                data.generalPageSection.forEach(function (section) {
                    for (var item in section.model) {
                        if (responce.hasOwnProperty(item)) {
                            var column = ListGridHelper.getColumnByFieldName(item);
                            ListGridHelper.convertByColumnType(responce, column, section.model, item);
                            self.originalModel[item] = data.model[item] = responce[item];
                        }
                    }
                });
            }

            self.ComposeData();

        }

        return (EditForm);
    }]);
